<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.title"
            name="title"
            label="Title"
            help-text="The title of the file."
            :error="(errors.title || [])[0]"
        />

        <CkEditorFormGroup
            v-model="data.text"
            name="text"
            label="Text"
            help-text="The text of the file."
            :error="(errors.text || [])[0]"
        />

        <TextFormGroup
            v-if="edit"
            v-model="data.path"
            name="path"
            label="Path"
            help-text="The path of the file."
            :error="(errors.path || [])[0]"
        />

        <SelectFormGroup
            v-model="data.content_file_category_id"
            name="content_file_category_id"
            label="Category"
            :error="(errors.content_file_category_id || [])[0]"
            :options="contentFileCategoryOptions"
        />

        <FormGroup v-if="!edit" name="file" label="File" :error="(errors.file || [])[0]">
          <input
              type="file"
              class="form-control"
              id="file"
              @change="data.file = $event.target.files[0]"
          >
        </FormGroup>

        <div>
          <button type="submit" class="btn btn-black pull-left" style="margin-bottom: 22px">
            <i class="fa fa-save"></i> Save
          </button>

          <a
              v-if="edit"
              :href="'/storage/content-files/' + data.download_path"
              class="btn btn-white pull-right"
              style="border: 1px solid #000000;"
              download
          >
            <i class="fas fa-cloud-download-alt"></i> Download
          </a>

          <div class="clearfix"></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Block/CkEditor'

export default {
  components: {
    FormGroup,
    SelectFormGroup,
    SubmitFormGroup,
    TextFormGroup,
    CkEditorFormGroup,
  },

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    companyId: {
      required: true,
      type: [String, Number]
    },

    contentFileCategories: {
      required: true,
      type: Array
    },

    edit: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  },

  computed: {
    contentFileCategoryOptions() {
      return this.contentFileCategories.map(contentFileCategory => ({
        value: contentFileCategory.id,
        label: contentFileCategory.attributes.name
      }))
    }
  }
}
</script>
